import React from 'react';
import dayjs from 'dayjs';
import { styled } from '@mui/material/styles';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import TableBasicLabel from '../../common/labels/TableBasicLabel/TableBasicLabel';
import StatusColorPoint from '../../common/labels/StatusColorPoint/StatusColorPoint';
import colors from '../../../scss/colors';
import { generalEnums } from '../../../utils/enums';
import ThreeDotMenu from '../../common/ThreeDotMenu/ThreeDotMenu';
import { timesheetsStatuses } from '../../../utils/constants';

const styleConfig = {
  amount: { width: { min: '150px', max: '150px' } },
  status: { width: { min: '104px', max: '104px' } },
  threedot: { width: { min: '80px', max: '80px' } }
};

const ThreeDotContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: '24px'
}));

const ThreeDotItem = styled('p')(() => ({
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '20px',
  lineHeight: '24px',
  color: '#77787b',
  cursor: 'pointer'
}));

const columns = (t, isApprover, deleteHandler, isFocus) => {
  const commonColumns = [
    {
      id: 'comment',
      name: () => (
        <TableBasicLabel
          text={t('dashboard.expenses.table.claimdescription')}
          fontColor="white"
          withForceBrake="max-content"
        />
      ),
      alignment: 'flex-start',
      value: (data) => (
        <TableBasicLabel
          text={data?.ClaimDescription}
          fontColor={colors.NAVY_BLUE}
          fontSize="20px"
          lineHeight="24px"
          fontWeight={500}
          withForceBrake="max-content"
          isTruncate
        />
      ),
      footer: () => {}
    },
    {
      id: 'Contractor',
      name: () => (
        <TableBasicLabel
          text={t('dashboard.expenses.table.contractor')}
          fontColor="white"
          withForceBrake="max-content"
        />
      ),
      alignment: 'flex-start',
      value: (data) => (
        <TableBasicLabel
          text={`${data?.User?.FirstName} ${data?.User?.LastName}`}
          fontColor={colors.PRIMARY_BLUE}
          fontSize="16px"
          lineHeight="19px"
          fontWeight={400}
          withForceBrake="max-content"
        />
      ),
      footer: () => {}
    },
    {
      id: 'date',
      name: () => (
        <TableBasicLabel text={t('dashboard.expenses.table.date')} fontColor="white" withForceBrake="max-content" />
      ),
      alignment: 'flex-start',
      value: (data) => (
        <TableBasicLabel
          text={dayjs(data.CreatedDate).format(generalEnums.DATEWITH_MMM)}
          fontColor={colors.NAVY_BLUE}
          fontSize="16px"
          lineHeight="19px"
          fontWeight={400}
          withForceBrake="max-content"
        />
      ),
      footer: () => {}
    },
    {
      id: 'amount',
      width: styleConfig.amount.width,
      alignment: 'flex-start',
      name: () => (
        <TableBasicLabel text={t('dashboard.expenses.table.amount')} fontColor="white" withForceBrake="max-content" />
      ),
      value: (data) => (
        <>
          <p
            style={{
              color: colors.NAVY_BLUE,
              fontSize: '20px',
              fontWeight: 600
            }}
          >
            {data?.ExpenseCurrency?.Symbol || data?.ExpenseCurrency?.CurrencyName}
          </p>
          <TableBasicLabel
            text={data?.TotalExpense}
            fontColor={colors.NAVY_BLUE}
            fontSize="20px"
            lineHeight="24px"
            fontWeight={500}
            withForceBrake="max-content"
          />
        </>
      ),
      footer: () => {}
    },
    {
      id: 'status',
      width: styleConfig.status.width,
      alignment: 'flex-start',
      name: () => (
        <TableBasicLabel text={t('dashboard.timesheets.table.status')} fontColor="white" withForceBrake="max-content" />
      ),
      value: (data) => <StatusColorPoint status={data.Status.Status.toLowerCase()} isApprover={isApprover} />,
      footer: () => {}
    },
    {
      id: 'threedot',
      width: styleConfig.threedot.width,
      alignment: 'flex-end',
      name: () => ' ',
      value: (data) => {
        return !isApprover && data.Status.Status === timesheetsStatuses(t).draft.apiStatus ? (
          <ThreeDotMenu
            menuComponent={
              <MoreVertOutlinedIcon sx={{ color: '#A3B4C7', fontSize: '24px', opacity: isFocus === data.Id ? 1 : 0 }} />
            }
          >
            <ThreeDotContainer>
              <ThreeDotItem onClick={() => deleteHandler(data.Id)}>
                {t('dashboard.expenses.threedot.delete')}
              </ThreeDotItem>
            </ThreeDotContainer>
          </ThreeDotMenu>
        ) : null;
      },
      footer: () => {}
    }
  ];

  const columnsArray = isApprover ? commonColumns : commonColumns.filter((item) => item.id !== 'Contractor');
  return columnsArray;
};

export { columns };
